export const imageSkeleton = `<svg
      width="400"
      height="400"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient id="g">
          <stop stop-color="#F8FAFC" offset="20%" />
          <stop stop-color="#F1F5F9" offset="50%" />
          <stop stop-color="#F8FAFC" offset="70%" />
        </linearGradient>
      </defs>
      <rect width="400" height="400" fill="#F8FAFC" />
      <rect id="r" width="400" height="400" fill="url(#g)" />
      <animate xlink:href="#r" attributeName="x" from="-400" to="400" dur="1s" repeatCount="indefinite" />
    </svg>`;

export const toBase64 = (str: string): `data:image/${string}` => {
  const base64Str = typeof window === "undefined" ? Buffer.from(str).toString("base64") : window.btoa(str);
  return `data:image/svg+xml;base64,${base64Str}`;
};
